import { Component } from "@angular/core";
import {
  AbstractControlOptions,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { IPassword } from "@app/auth/models/iPassword.model";
import { FeedbackType } from "@app/shared/models/feedbackType";
import { FeedbackService } from "@app/shared/services/feedback/feedback.service";
import { SnackbarService } from "@app/shared/services/snackbar/snackbar.service";
import { TextService } from "@app/shared/services/text/text.service";
import { NgIconComponent, provideIcons } from "@ng-icons/core";
import { heroEye, heroEyeSlash } from "@ng-icons/heroicons/outline";

import { SliderComponent } from "../../../shared/slider/slider.component";
import { AuthService } from "../../services/authentication/auth.service";
import { passwordMatchValidator } from "../../services/validators/password-match.validator";

@Component({
  selector: "app-forgot-password",
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgIconComponent, SliderComponent],
  templateUrl: "./change-password.component.html",
  styleUrl: "./change-password.component.scss",
  viewProviders: [provideIcons({ heroEye, heroEyeSlash })],
})
export class ChangePasswordComponent {
  constructor(
    private snackbar: SnackbarService,
    private textService: TextService,
    private router: Router,
    private fb: FormBuilder,
    private auth: AuthService,
    private feedback: FeedbackService
  ) {
    // this.auth.autoLogin();
  }

  form = this.fb.group(
    {
      oldPassword: ["", [Validators.required, Validators.minLength(8)]],
      newPassword: ["", [Validators.required, Validators.minLength(8)]],
      confirmPassword: ["", [Validators.required, Validators.minLength(8)]],
    },
    {
      validators: [passwordMatchValidator("password", "confirmPassword")],
    } as AbstractControlOptions
  );

  inputType = ["password", "password"];
  showPassword = [false, false];

  onSubmit() {
    const { oldPassword, newPassword, confirmPassword } = this.form.value;

    if (newPassword !== confirmPassword) {
      this.snackbar.showError(
        this.textService.labels.auth.error.invalidPasswordConfirmation
      );
    } else if (oldPassword && newPassword) {
      const passwordData: IPassword = {
        oldPassword,
        newPassword,
      };
      this.auth.changePassword(passwordData).subscribe({
        next: () => {
          this.feedback.openModal(
            FeedbackType.SUCCESS,
            "Sucesso!",
            "Senha atualizada"
          );
          this.router.navigate(["/login"]);
        },
        error: (error) => {
          this.feedback.openModal(FeedbackType.ERROR, "Oops!", error);
        },
      });
    }
  }

  toggleVisibility(index: number) {
    this.showPassword[index] = !this.showPassword[index];
    this.inputType[index] = this.showPassword[index] ? "text" : "password";
  }
}
